import { render } from "./UsersGestaoTab.vue?vue&type=template&id=3442f67f&scoped=true&ts=true"
import script from "./UsersGestaoTab.vue?vue&type=script&lang=ts"
export * from "./UsersGestaoTab.vue?vue&type=script&lang=ts"

import "./UsersGestaoTab.vue?vue&type=style&index=0&id=3442f67f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3442f67f"]])

export default __exports__